import { call, cancel, put, select, spawn } from 'redux-saga/effects';
import analytics from '../../../utils/analytics';
import createTourRadarSession, {
  RadarSessionFailures,
} from '../../../helpers/createTourRadarSession';
import getTourPublishableKey from '../../../helpers/selectors/getTourPublishableKey';
import { bookTripFailure } from '../../slices/trip';

const readFailureMessage = (failure) =>
  failure === RadarSessionFailures.noPublishableKey
    ? 'Tour payments are not set up for this agency, so the tour cannot be booked.'
    : 'We could not reach the tour payment service. Allow js.stripe.com (ad blocker or network) and try again.';

// The backend refuses a tour without a Radar session, but only after the other segments of the
// same request are booked and charged, so a tour still to book without one stops the attempt here.
function* buildRadarSessionBySegment({ toursToBook, tripId }) {
  const sessionBySegment = {};
  if (!toursToBook || toursToBook.length === 0) {
    return sessionBySegment;
  }

  const publishableKey = yield select(getTourPublishableKey);
  const session = yield call(createTourRadarSession, publishableKey);

  if (session.failure) {
    yield spawn([analytics, 'track'], 'bookTripWorker.bookTrip.tourRadarSessionMissing', {
      tripId,
      reason: session.failure,
      message: session.message,
      tourCount: toursToBook.length,
    });
    yield put(bookTripFailure({ error: readFailureMessage(session.failure) }));
    yield cancel();
  }

  toursToBook.forEach((tour) => {
    sessionBySegment[tour.tripSegmentId] = session.sessionId;
  });

  return sessionBySegment;
}

export default buildRadarSessionBySegment;
